/**
 * PrivacidadLegalesPage component
 * @returns <PrivacidadLegalesPage />
 */
import Breadcrumbs from "../components/Breadcrumbs"
import Accordion from "../components/Accordion"
import { useGetPoliticasDePrivacidadDataQuery } from "../redux/apiSlice";
import Loader from "../components/Loader";
import { AnimatePresence } from "framer-motion";
import { useLocation } from "react-router-dom";

const PrivacidadLegalesPage = () => {
    const location = useLocation();

    const BreadcrumbsProps = {
        links: [
            {
                link: "/",
                label: "Inicio"
            },
            {
                link: location.pathname,
                label: "Privacidad y legales"
            },
        ],
    }

    const {
        data,
        isLoading,
        isFetching,
        isSuccess,
        isError
    } = useGetPoliticasDePrivacidadDataQuery();

    return (
        <>
            {isLoading && (
                <AnimatePresence>
                    <Loader />
                </AnimatePresence>
            )}
            {isSuccess && (
                <>
                    <Breadcrumbs {...BreadcrumbsProps} />

                    <section className="ayuda" style={{ backgroundColor: "white" }}>
                        <div className="wrapper">
                            <h1>{data.title}</h1>

                            <Accordion items={data.accordion.items} />
                        </div>
                    </section>
                </>
            )}
            {isError && <p>Hubo un error</p>}
        </>
    )
}

export default PrivacidadLegalesPage